<template>
  <div id="tabLclContainer" class="app-main-content">
    <cargo-up-down-resize
      class="main-content"
      :up-style="{ display: 'flex', flexDirection: 'column', paddingBottom: '5px' }"
      :down-style="{ display: 'flex', flexDirection: 'column', paddingTop: '5px' }"
      style="height: 100%"
    >

      <template slot="up">
        <div v-show="isEdit || enableUiCustom" class="section">
          <span v-if="enableUiCustom" class="title" style="margin: 7px 10px 7px 0px;">{{ $t('SeaExport.WarehouseEntryInformation') }}</span>
          <div v-show="isEdit">
            <el-button no="1" type="primary" @click="pm.addSlaveHandler()">{{ $t('SeaExport.AddTickets') }}</el-button>
            <el-button no="2" type="danger" @click="pm.removeSlaveHandler()">{{ $t('SeaExport.RemoveTickets')
            }}</el-button>
          </div>
        </div>
        <div class="section" style="flex: 1">
          <cargo-ag-grid
            no="3"
            config-module="130116"
            :grid-options="gridOptions"
            :grid-params.sync="gridParams"
            :column-defs="finalColumnDefs"
            :row-data="lclSlaves"
            style="width:100%;flex:1"
            @gridReady="params => gridApi = params.api"
          />
        </div>
        <div style="padding:5px 0">
          <div style="float:left">
            <span v-if="enableUiCustom" class="title" style="margin: 7px 10px 7px 0px;">{{ $t('SeaExport.ContainerInfo') }}</span>
            <!--拆分主票-->
            <el-button
              v-show="showSplitButton && viewSource != 'salesDetail'"
              no="4"
              type="primary"
              @click="pm.splitClickEventHandler()"
            >{{ $t('SeaExport.SplitHbl') }}</el-button>
            <el-button v-show="openXhqCustomsAll" no="xhqShowSendContainerHandler" type="primary" @click="xhqShowSendContainerHandler">{{ $t('CargoMsg.SendContainer') }}</el-button>
            <el-button v-show="openXhqCustomsAll" no="xhqCustomsUnFrozenHandler" type="primary" @click="toXhqCustomsUnFrozenHandler">{{ $t('CargoMsg.CustomsUnFrozen') }}</el-button>
            <el-button v-show="isEdit" no="5" type="primary" @click="changeSealHandler">{{
              $t('SeaExport.SealNoChangeAdfterInspection') }}</el-button>
            <el-button
              v-show="isEdit"
              no="6"
              type="info"
              plain
              style="color:green"
              @click="pm.addToContainerHandler()"
            >↓</el-button>
            <el-button
              v-show="isEdit"
              no="7"
              type="info"
              plain
              style="color:red"
              @click="p=>{pm.removeToContainerHandler();changeLclSlaves()}"
            >↑</el-button>
            <el-badge v-show="isEdit" no="8" :is-dot="harbourCheckRead" class="item">
              <el-button v-show="isEdit" no="9" class="share-button" type="primary" @click="harbourCompare">{{
                $t('SeaExport.DataComparison') }}</el-button>
            </el-badge>
            <el-button
              v-show="isEdit"
              no="10"
              type="primary"
              style="margin-left: 5px;"
              size="mini"
              @click="harbourSync"
            >{{ $t('SeaExport.SynchronizePortData') }}</el-button>
          </div>
          <div style="display: flex; align-items: center; gap: 16px;margin-left: 200px;">
            <el-button v-if="jingyuWarehouse" no="ReleaseJY" type="primary" @click="toReleaseJY">{{ $t('SeaExport.ReleaseJY') }}</el-button>
            <el-button v-if="jingyuWarehouse" no="TakeContainerJY" type="primary" @click="toTakeContainerJY">{{ $t('SeaExport.TakeContainerJY') }}</el-button>
            <el-button v-if="jingyuWarehouse" no="ContainerPreloadJY" type="primary" @click="toContainerPreloadJY">{{ $t('SeaExport.ContainerPreloadJY') }}</el-button>
            <el-button v-if="toExoSystemJYD && job.masterFlag" :disabled="!(!jydEnable && !isEdit && job.jobState === 0)" no="canPushPreConfiguration" type="primary" @click="toCanPushPreConfiguration">{{ $t('SystemMaintenance.canPushPreConfiguration') }}</el-button>
          </div>
          <div style="float:right">
            <el-form :inline="true" label-width="55px" label-position="left">
              <el-form-item :label="totalLabel.package" class="custom">
                <el-input v-model="slaveTotalDesc.slaveTotalQuantity" no="11" style="width:100px" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.TotalWeight')" class="custom">
                <el-input v-model="slaveTotalDesc.slaveTotalWeight" no="12" style="width:100px" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.TotalCubage')" class="custom">
                <el-input v-model="slaveTotalDesc.slaveTotalCubage" no="13" style="width:100px" />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>

      <template slot="down">
        <cargo-left-right-resize
          :left-style="{ display: 'flex', flexDirection: 'column', width: '20%' }"
          :right-style="{ display: 'flex', flexDirection: 'column', width: '80%' }"
          style="height: 100%;min-height: 300px"
        >
          <template slot="left">
            <div class="section" style="flex: 1">
              <cargo-ag-grid
                no="14"
                config-module="130117"
                :grid-options="left.gridOptions"
                :grid-params.sync="left.gridParams"
                :column-defs="containerColumnDefs"
                :row-data="containers"
                style="height:100%"
                @gridReady="params => left.gridApi = params.api"
              />
            </div>
          </template>
          <template slot="right">
            <div class="section" style="flex: 1;">
              <cargo-ag-grid
                no="15"
                config-module="130118"
                :grid-options="right.gridOptions"
                :grid-params.sync="right.gridParams"
                :column-defs="usageColumnDefs"
                :row-data="selectedContainer.containerUsage"
                style="flex-grow:1"
                @gridReady="params => right.gridApi = params.api"
              />
            </div>
            <div style="padding:5px 0">
              <div style="float:left">
                <span>{{ usagesTotalDesc.txtNum }}</span>
              </div>
              <div v-if="jingyuWarehouse" class="lcl-dynamic-div">
                <span v-show="jingyuWarehouse && !isEdit" class="lcl-dynamic-span" @click="showLclDynamicList"> {{ $t('SeaExport.LclDynamic') }} <i :class="jyLclDynamicDialog.visible?'el-icon-caret-bottom':'el-icon-caret-top'" /> </span>
              </div>
              <div style="float:right">
                <el-form :inline="true" label-width="55px" label-position="left">
                  <el-form-item :label="totalLabel.package" class="custom">
                    <el-input v-model="usagesTotalDesc.usageTotalQuantity" no="16" style="width:100px" />
                  </el-form-item>
                  <el-form-item :label="totalLabel.weight" class="custom">
                    <el-input v-model="usagesTotalDesc.usageTotalWeight" no="17" style="width:100px" />
                  </el-form-item>
                  <el-form-item :label="totalLabel.cubage" class="custom">
                    <el-input v-model="usagesTotalDesc.usageTotalCubage" no="18" style="width:100px" />
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </template>
        </cargo-left-right-resize>
      </template>
    </cargo-up-down-resize>
    <!-- 查验更改封号弹窗 -->
    <seal-number-change-dialog
      :visible.sync="boxNoDialog.visible"
      :prop-form-data="selectedContainer"
      @sealCloseHandler="sealCloseHandler"
    />

    <!-- 加入拼箱工作单查询弹窗 -->
    <query-se-lcl-dialog
      :visible.sync="querySELclDialog.visible"
      :job="job"
      @callback="rows => { pm.slaveAddedHandler(rows) }"
    />

    <!-- 港区数据对比弹窗 -->
    <lcl-compare-harbour-dialog
      :visible.sync="harbourDialog"
      :data-source="containers"
      :harbour-source="sourceList"
      :job="job"
      :lcl-slave-so-no="lclSlaveSoNo"
      :hc-flag="hcFlag"
      :hq-flag="hqFlag"
      :container-height-flag="containerHeightFlag"
      :h-q-h-c-flag="HQHCFlag"
      @addContainer="handleAddContainer"
    />

    <!-- 箱子信息对比提示弹窗 -->
    <box-Information-Verification
      :dialog-visible.sync="portareaDialogVisible"
      :content-show="contentShow"
      :container="container"
    />

    <el-dialog :title="$t('FileHistory.Tips')" :visible.sync="dialogVisible" width="30%">
      <div class="portData-check">
        <i class="el-icon-error" /><strong>S/O NO{{ $t('SeaExport.ItPortDataAndVerified') }}</strong>
        <p>{{ $t('SeaExport.TheNotContainTheData') }}S/O NO.</p>
        <p v-for="item in checkSoNo" :key="item">{{ item }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" no="19" @click="dialogVisible = false">{{ $t('Message.GotIt') }}</el-button>
      </span>
    </el-dialog>

    <!-- 发送装箱信息到信号旗 -->
    <xhq-send-container-dialog
      :dialog-visible.sync="xhqSendContainerDialog.visible"
      :job="job"
      :container-usage="xhqSendContainerDialog.containerUsage"
      :selected-container="selectedContainer"
    />
    <!-- 精谕放单弹窗 -->
    <jy-release-dialog :job="job" :containers="containers" :visible.sync="jyReleaseDialog.visible" />
    <!-- 精谕提箱弹窗 -->
    <jy-take-container-dialog :job="job" :containers="jyTakeContainerDialog.containers" :visible.sync="jyTakeContainerDialog.visible" />
    <!-- 精谕装箱弹窗 -->
    <jy-container-preload-dialog :job="job" :containers="jyContainerPreloadDialog.containers" :visible.sync="jyContainerPreloadDialog.visible" />
    <!-- 精谕拼箱动态弹窗 -->
    <jy-lcl-dynamic-dialog :job-uuid="job.uuid" :visible.sync="jyLclDynamicDialog.visible" />
  </div>
</template>

<script>

import cargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import querySeLclDialog from '@/components/Cargo/Job/querySELclDialog'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { TabLclContainerBase } from './tabLclContainerBase'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import SealNumberChangeDialog from '@/components/Cargo/Job/sealNumberChangeDialog'
import ContainerNoHelper from '@/utils/containerNoHelper'
import { DataPushCompareUtils } from '@/class/cargo/model/utils/DataPushCompareUtils'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import { Job } from '@/class/model/booking/Job'
import { Container } from '@/class/model/booking/Container'
import { deepClone, sortByMultiField } from '@/utils'
import { formatNumberToThousands } from '@/utils'
import { isNumber } from '@/utils/validate'
import { roundHalfUp } from '@/utils/NumberUtils'
import { getGoodsTmpInfoByJobId, checkRead, updateRead } from '@/api/seaExport/containerUsage'
import { getOpenPortDataService } from '@/api/sysManage/subscribePortPushRule'
import LclCompareHarbourDialog from '@/components/Cargo/Job/lclCompareHarbourDialog'
import { PortDataCompareUtils } from '@/class/cargo/model/utils/PortDataCompareUtils'
import StrUtils from '@/utils/StrUtils'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor/index'
import * as CommonUtil from '@/utils/commonUtil'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import BoxInformationVerification from './TabDataTracking/components/boxInformationVerification'
import { portContainerInfo } from '@/api/seaExport/dataTracking'
import XhqSendContainerDialog from '@/components/Cargo/Job/xhqSendContainerDialog'
import { jydSendJobInfo, xhqGetContainerLclList } from '@/api/seaExport/seaCargoDoc'
import { xhqCustomsUnFrozen, xhqGetCustomsUnFrozenState } from '@/api/seaExport/customsInfo'
import { getObjectByCache } from '@/utils/basicDataCache'
import * as XhqCustomState from '@/class/cargo/model/parameters/XhqCustomState'
import JyReleaseDialog from '@/components/Cargo/Job/jyReleaseDialog.vue'
import JyTakeContainerDialog from '@/components/Cargo/Job/jyTakeContainerDialog.vue'
import JyContainerPreloadDialog from '@/components/Cargo/Job/jyContainerPreloadDialog.vue'
import { checkIfReleased } from '@/api/booking/jyWarehouse'
import JyLclDynamicDialog from '@/components/Cargo/Job/jyLclDynamicDialog'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import CargoAgGridSoNoInputEditor from '@/components/Cargo/Common/CargoAgGridSoNoInputEditor'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import LocalStorageUtils from '@/utils/localStorageUtils'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import { warehouseInList } from '@/api/seaExport/warehouseIn'

export default {
  name: 'TabLclContainer',
  components: {
    XhqSendContainerDialog, LclCompareHarbourDialog, SealNumberChangeDialog, cargoUpDownResize, cargoLeftRightResize, querySeLclDialog, BoxInformationVerification,
    JyReleaseDialog, JyTakeContainerDialog, JyContainerPreloadDialog, JyLclDynamicDialog, CargoAgGridAdvanceSelectEditor },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    location: { // 日志【模块位置】,【数据更新日志】使用
      type: String,
      default: ''
    },
    masterCustomsDeclarationEnable: { // 【主票】关单信息 是否可用
      type: Boolean,
      default: false
    },
    enableUiCustom: { type: Boolean, default: false }, // 是否启用UI自定义
    previewConfig: { type: Object, default: null } // 预览配置
  },
  data() {
    return {
      pm: new TabLclContainerBase(this),
      contentShow: true,
      hasCompareYet: false,
      container: {
        harbourDistrict: [],
        basicTab: []
      },
      portareaDialogVisible: false,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowSelection: false,
        suppressRowClickSelection: false,
        rowMultiSelectWithClick: false,
        context: {
          componentParent: this
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: this.onRowClicked
      },
      columnDefs: [
        {
          headerName: '',
          colId: 'uuid',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: 'warehouseNo',
          width: 120
        },
        {
          headerName: 'MBL',
          field: 'mbl',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          field: 'customerId',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: 'S/O No',
          field: 'soNo',
          width: 120,
          hide: true,
          valueFormatter: (params) => {
            return params.value ? params.value.replace(/\n/g, ',') : ''
          }
        },
        {
          headerName: this.$t('SeaExport.PortOfDischarge'),
          field: 'dischargingPortCode',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.PlaceOfDelivery'),
          field: 'destinationPortCode',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: 'ETD',
          field: 'etd',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'cargoChineseName',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.Package'),
          field: 'packing',
          width: 120,
          valueFormatter: params => {
            return ColumnUtils.packingCodeLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantityStr',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'),
          field: 'weightStr',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubageStr',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedQuantity'),
          field: 'quantityContractStr',
          width: 100,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CommissionedGrossWeight'),
          field: 'weightContractStr',
          width: 100,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedCubage'),
          field: 'cubageContractStr',
          width: 100,
          hide: true
        },
        {
          headerName: this.$t('queryJob.destinationAgent'),
          field: 'destinationAgent',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_2') : ''
          },
          width: 200,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_3') : ''
          },
          width: 200,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.UserDefinedField1'),
          field: 'userDefinedField1',
          width: 150,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.UserDefinedField2'),
          field: 'userDefinedField2',
          width: 150,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.UserDefinedField3'),
          field: 'userDefinedField3',
          width: 150,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.UserDefinedField4'),
          field: 'userDefinedField4',
          width: 150,
          hide: true
        },
        {
          headerName: this.$t('queryJob.BusinessRemarks'),
          field: 'remarks',
          width: 150,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.OperationTips'),
          field: 'operationTips',
          width: 120,
          hide: true
        },
        {
          headerName: 'HSCODE',
          field: 'hsCode',
          width: 120
        }
      ],
      gridApi: null,
      left: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          frameworkComponents: { // 添加编辑组件
            CargoAgGridDateTimeEditor,
            CargoAgGridCommonTextareaEditor
          },
          // 选中 勾选框或者其他列 都会触发
          onCellFocused: (event) => {
            this.onCellFocusedContainer(event)
          },
          onRowClicked: this.containerChangeHandler
        },
        gridApi: null
      },
      right: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowSelection: false,
          suppressRowClickSelection: false,
          rowMultiSelectWithClick: false,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridCommonTextareaEditor,
            CargoAgGridSoNoInputEditor,
            CargoAgGridAdvanceSelectEditor
          },
          context: {
            componentParent: this
          }
        },
        gridApi: null
      },
      boxNoDialog: {
        visible: false
      },
      querySELclDialog: {
        visible: false
      },
      containerUsageColl: [], // 装箱信息
      selectedContainer: new Container().fillDefaultValue().getData(), // 选中的箱子
      job: new Job().fillDefaultValue().getData(),
      containers: [], // 箱子列表
      lclSlaves: [],
      slaveTotalDesc: { // 合计汇总
        slaveTotalQuantity: '',
        slaveTotalWeight: '',
        slaveTotalCubage: ''
      },
      usagesTotalDesc: { // 合计汇总
        txtNum: '',
        usageTotalQuantity: '',
        usageTotalWeight: '',
        usageTotalCubage: ''
      },
      totalLabel: { // 合计汇总label
        package: this.$t('SeaExport.TotalNumberOfPackages') + ':',
        weight: this.$t('SeaExport.TotalWeight') + ':',
        cubage: this.$t('SeaExport.TotalCubage') + ':'
      },
      operationTipsAarry: [], // 记录修改的 operationTips
      selectedSlave: {}, // 选中的小票
      hasSoNo: true, // 小票是否有soNo
      lclSlaveSoNo: {}, // soNo与小票UUID
      checkSoNo: [],
      openPortDataService: 1, // 港区推送状态 1）不在服务范围内，且没开通服务；2）在服务范围内，且没开通服务；3）不在服务范围内，且开通服务；4）在数据服务范围内，且开通服务
      harbourList: [], // 港区推送数据,
      mergeHarbourList: [], // 港区数据合并(即合并货物信息)
      harbourCheckRead: false, // 校验港区数据推送是否已读
      harbourDialog: false, // 数据对比弹框
      sourceList: [], // 对比数据源
      poItems: [],
      selection: [],
      dialogVisible: false,
      containerHeightFlag: true,
      xhqSendContainerDialog: {
        visible: false,
        containerUsage: []
      },
      xinHaoQiApi: 0,
      jingyuWarehouse: false,
      jyReleaseDialog: {
        visible: false
      },
      jyTakeContainerDialog: {
        visible: false,
        containers: []
      },
      jyContainerPreloadDialog: {
        visible: false,
        containers: []
      },
      toExoSystemJYD: false,
      jydEnable: false,
      jyLclDynamicDialog: {
        visible: false
      },
      isUppercaseByConfig: true, // CARGO-49117 是否大写
      warehouseElementDict: {},
      containerElementDict: {},
      portElementDict: {},
      warehouseQWCMap: new Map()
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    // 显示拆分主票按钮
    showSplitButton() {
      return this.action === 'look'
    },
    openXhqCustomsAll() { // 信号旗参数等于2，推送信号旗报关单，同时接收回传文件 (完整模式)
      return this.xinHaoQiApi === 2
    },
    finalColumnDefs() {
      if (this.enableUiCustom) {
        const columnDefs = [...this.columnDefs]
        columnDefs.push({
          headerName: this.$t('SeaExport.NumberOfItemsReceived'),
          field: 'warehouseQuantity'
        })
        columnDefs.push({
          headerName: this.$t('SeaExport.GrossWeightUponEntry'),
          field: 'warehouseWeight',
          valueFormatter: (params) => {
            return NumberUtils.formatNumber(params.value, 3)
          }
        })
        columnDefs.push({
          headerName: this.$t('SeaExport.WarehouseVolume'),
          field: 'warehouseCubage',
          valueFormatter: (params) => {
            return NumberUtils.formatNumber(params.value, 3)
          }
        })
        return UICustomUtil.handleColumnLabelAndDisplay(columnDefs, this.warehouseElementDict)
      }
      return this.columnDefs
    },
    containerColumnDefs() {
      const columnDefs = [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.PortInformationVerification'),
          colId: 'confirmed',
          field: 'confirmed',
          width: 100,
          valueFormatter: (params) => {
            if (params.value) {
              let text = ''
              switch (params.value) {
                case 0:
                  text = this.$t('SeaExport.NotVerified')
                  break
                case 10:
                  text = this.$t('SeaExport.SystemVerification')
                  break
                case 11:
                  text = this.$t('SeaExport.ManualVerification')
                  break
                case 12:
                  text = this.$t('SeaExport.ManualVerification')
                  break
                case 13:
                  text = this.$t('SeaExport.ManualVerification')
                  break
                default:
                  text = this.$t('SeaExport.ToBeConfirmed2')
                  break
              }
              return text
            } else {
              return this.$t('SeaExport.NotVerified')
            }
          }
        },
        {
          // 码头配载
          headerName: this.$t('SeaExport.WharfStowage'),
          colId: 'wharfStowage',
          field: 'wharfStowage',
          valueFormatter: (params) => {
            if (params.data.wharfStowage) {
              return params.data.wharfStowageState ? `${params.data.wharfStowageState}(${params.data.wharfStowage})` : params.data.wharfStowage
            } else {
              return params.data.wharfStowageState ? params.data.wharfStowageState : ''
            }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'eqSize',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'eqType',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              isUppercase: true,
              isTrim: true,
              classFunc: (params) => {
                return this.containerNbrStyleFunction(params.data)
              }
            },
            valueChanged: p => {
              this.containerItemEditEndHandler(p)
            },
            multiplePaste: { isUppercase: true, isTrim: true }
          }
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNo',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              isUppercase: true,
              isTrim: true
            },
            valueChanged: p => { this.containerItemEditEndHandler(p) },
            multiplePaste: { isUppercase: true, isTrim: true }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerWeight'),
          field: 'containerWeight',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            precision: 3,
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3, true))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => {
              this.containerItemEditEndHandler(p)
            },
            multiplePaste: { isNumber: true, precision: 3 }
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          hide: true,
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'span',
            attrs: {
              classFunc: (params) => { return ContainerUtil.containerPushDataStyleFunction(params.data, 'quantity') },
              textConverter: (val) => {
                return !val ? '' : ColumnUtils.numberColumnLabelFunc(val)
              }
            },
            valueChanged: p => {
              this.containerItemEditEndHandler(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'),
          field: 'weight',
          hide: true,
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'span',
            attrs: {
              classFunc: (params) => { return ContainerUtil.containerPushDataStyleFunction(params.data, 'weight') },
              textConverter: (val) => {
                return !val ? '' : ColumnUtils.number3ColumnLabelFunc(val)
              }
            },
            valueChanged: p => {
              this.containerItemEditEndHandler(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          hide: true,
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'span',
            attrs: {
              classFunc: (params) => { return ContainerUtil.containerPushDataStyleFunction(params.data, 'cubage') },
              textConverter: (val) => {
                return !val ? '' : ColumnUtils.number3ColumnLabelFunc(val)
              }
            },
            valueChanged: p => {
              this.containerItemEditEndHandler(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.Inspection'),
          field: 'inSpected',
          width: 120,
          cellRenderer: (params) => {
            return this.subInSpectedLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('SeaExport.ApproachDate'),
          field: 'approachDate',
          hide: true,
          width: 120
        },
        {
          headerName: this.$t('SeaExport.PlayDate'),
          field: 'playDate',
          hide: true,
          width: 120
        },
        {
          headerName: this.$t('SeaExport.LoadingPort'),
          field: 'loadingPort',
          hide: true,
          width: 120
        },
        {
          headerName: this.$t('SeaExport.PortOfDestination'),
          field: 'destinationPort',
          hide: true,
          width: 120
        },
        {
          headerName: this.$t('SeaExport.TheArrivalOfPacketsSent'),
          field: 'transportMessageDate',
          hide: true,
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          // 海关放行信息
          headerName: this.$t('SeaExport.CustomsClearanceInfo'),
          field: 'customReleaseDate',
          hide: true,
          width: 150,
          valueFormatter: (params) => {
            if (params.data.customReleaseState === 'R') {
              return 'R(' + this.$t('SeaExport.CancelCustomsClearance') + ')'
            }
            if (params.data.customReleaseState) {
              return params.data.customReleaseState === 'Y' ? `${params.data.customReleaseState}(${params.data.customReleaseDate})` : params.data.customReleaseState
            } else {
              return params.data.customReleaseDate
            }
          }
        },
        {
          // 码头放行信息
          headerName: this.$t('SeaExport.WharfReleaseInfo'),
          field: 'wharfReleaseDate',
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            if (params.data.wharfReleaseState === 'R') {
              return 'R(' + this.$t('SeaExport.CancelDockRelease') + ')'
            }
            if (params.data.wharfReleaseDate) {
              return params.data.wharfReleaseState ? `${params.data.wharfReleaseState}(${params.data.wharfReleaseDate})` : params.data.wharfReleaseDate
            } else {
              return params.data.wharfReleaseState ? params.data.wharfReleaseState : ''
            }
          }
        },
        {
          headerName: this.$t('SeaExport.DestinationDeliveryTime'), field: 'destinationDeliveryTime', colId: 'destinationDeliveryTime', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          editable: this.isEdit,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false
            }
          },
          onCellValueChanged: p => this.containerItemEditEndHandler(p)
        },
        {
          headerName: this.$t('SeaExport.DestinationReturnTime'),
          field: 'destinationReturnTime',
          colId: 'destinationReturnTime',
          width: 150,
          valueFormatter: (params) => {
            return params.data.destinationReturnTime
          },
          editable: this.isEdit,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false
            }
          },
          onCellValueChanged: p => this.containerItemEditEndHandler(p)
        },
        {
          headerName: this.$t('SeaExport.ContainerAscription'),
          field: 'containerAscription',
          width: 150,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-select',
            optionField: {
              label: 'chineseName',
              value: 'code'
            },
            attrs: {
              cellSelectAttrs: { fullOptionsCBFunc: () => [...SeaExportConstants.CONTAINER_ASCRIPTION_TYPE] }
            },
            valueChanged: p => {
              this.containerItemEditEndHandler(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.PlateNumber'),
          field: 'plateNumber',
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.plateApproachDate'),
          field: 'plateApproachDate',
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.platePlayDate'),
          field: 'platePlayDate',
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remark',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          cellEditorParams: {},
          onCellValueChanged: p => this.containerItemEditEndHandler(p)
        },
        {
          headerName: this.$t('SeaExport.UnloadingTime'), field: 'portDischargeTime', colId: 'portDischargeTime', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              editable: false
            }
          },
          onCellValueChanged: p => this.containerItemEditEndHandler(p)
        },
        {
          headerName: this.$t('SeaExport.LiftingTime'), field: 'actualPickUpTime', colId: 'actualPickUpTime', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              editable: false
            }
          },
          onCellValueChanged: p => this.containerItemEditEndHandler(p)
        },
        {
          headerName: this.$t('SeaExport.ContainerId'),
          field: 'containerId',
          width: 80
        },
        {
          headerName: this.$t('SeaExport.ContainerSeqNo'),
          field: 'containerSeqNo',
          width: 80
        }
      ]
      if (this.enableUiCustom) {
        return UICustomUtil.handleColumnLabelAndDisplay(columnDefs, this.portElementDict)
      }
      return columnDefs
    },
    isJyd() { // 是否集翊达
      return this.context.config && String(this.context.config.get('ToExoSystem')) === 'JYD'
    },
    isJydEditJobFields() { // 有客服权限，没有操作权限，则不能编辑业务的某些字段【新增业务除外】
      return JobUtils.editJobFields(this.isJyd && this.job.uuid)
    },
    usageColumnDefs() {
      const columnDefs = [
        {
          headerName: this.$t('SeaExport.SequenceNumber'),
          field: 'serialNo',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: this.isEdit ? 'el-input-number' : 'span',
            precision: 0,
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: { isNumber: true, precision: 0 }
          }
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: 'warehouseNo',
          width: 120
        },
        {
          headerName: 'MBL',
          field: 'mbl',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          field: 'customerId',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: 'S/O No',
          field: 'soNo',
          width: 120,
          hide: true,
          valueFormatter: (params) => {
            return params.value ? params.value.replace(/\n/g, ',') : ''
          },
          editable: this.isEdit,
          cellEditor: 'CargoAgGridSoNoInputEditor',
          onCellValueChanged: params => this.onCellChange(params)
        },
        {
          headerName: this.$t('SeaExport.PortOfDischarge'),
          field: 'dischargingPortCode',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.PlaceOfDelivery'),
          field: 'destinationPortCode',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: 'ETD',
          field: 'etd',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('queryJob.englishDescriptionOfGoods'),
          colId: 'cargoName',
          field: 'cargoName',
          width: 100,
          hide: false,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          cellEditorParams: {
            autoUppercase: this.isUppercaseByConfig
          },
          onCellValueChanged: (params) => {
            params.data.cargoName = StrUtils.toHalfword(params.data.cargoName.trim())
            params.api.refreshCells({ columns: ['cargoName'] })
          },
          custom: {
            isEdit: this.isEdit,
            valueChanged: p => { this.onCellChange(p) }
          }
        }, {
          headerName: this.$t('SeaExport.Marks'),
          colId: 'mark',
          field: 'mark',
          width: 100,
          hide: false,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          cellEditorParams: {
            autoUppercase: this.isUppercaseByConfig
          },
          onCellValueChanged: (params) => {
            params.data.mark = StrUtils.toHalfword(params.data.mark.trim())
            params.api.refreshCells({ columns: ['mark'] })
          },
          custom: {
            isEdit: this.isEdit,
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.Soc'),
          field: 'soc',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'el-checkbox',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: 'HSCODE',
          field: 'hsCode',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: {}
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit && this.isJydEditJobFields,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              classFunc: (params) => {
                return ContainerUtil.containerPushDataStyleFunction(params.data, 'quantity')
              },
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 0, true))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: { isNumber: true, precision: 0 }
          }
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'),
          field: 'weight',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit && this.isJydEditJobFields,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              classFunc: (params) => {
                return ContainerUtil.containerPushDataStyleFunction(params.data, 'weight')
              },
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3, true))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: { isNumber: true, precision: 3 }
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit && this.isJydEditJobFields,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              classFunc: (params) => {
                return ContainerUtil.containerPushDataStyleFunction(params.data, 'cubage')
              },
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3, true))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: { isNumber: true, precision: 3 }
          }
        },
        {
          headerName: this.$t('SeaExport.OperationTips'),
          field: 'operationTips',
          width: 120,
          hide: true,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: {}
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedQuantity'),
          field: 'quantityContract',
          width: 100,
          hide: true,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 0, true))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: { isNumber: true, precision: 0 }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CommissionedGrossWeight'),
          field: 'weightContract',
          width: 100,
          hide: true,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3, true))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: { isNumber: true, precision: 3 }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedCubage'),
          field: 'cubageContract',
          width: 100,
          hide: true,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3, true))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => { this.onCellChange(p) },
            multiplePaste: { isNumber: true, precision: 3 }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DeclarationGrossWeight'),
          field: 'customsWeight',
          width: 100,
          hide: true,
          suppressColumnsToolPanel: !this.openXhqCustomsAll,
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.number3ColumnLabelFunc(params.value) : ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_NumberDeclaration'),
          field: 'customsQuantity',
          width: 100,
          hide: true,
          suppressColumnsToolPanel: !this.openXhqCustomsAll,
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.number3ColumnLabelFunc(params.value) : ''
          }
        },
        {
          headerName: this.$t('SeaExport.StatusOfCustomsDeclaration'),
          field: 'xhqCustomState',
          width: 100,
          hide: true,
          suppressColumnsToolPanel: !this.openXhqCustomsAll,
          cellRenderer: (params) => {
            if (params.value === XhqCustomState.SENT_LCL_TASK.code) {
              return this.$t('CargoMsg.LCLTaskSent')
            } else if (params.value === XhqCustomState.SENT.code) {
              return this.$t('CargoMsg.CustomerFileHasBeenSent')
            } else {
              return this.$t('CargoMsg.NotSendingCustomerFile')
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.CustomsUnFrozen'),
          field: 'customsUnfrozenState',
          width: 100,
          hide: true,
          suppressColumnsToolPanel: !this.openXhqCustomsAll,
          cellRenderer: (params) => {
            return !params.value ? this.$t('CargoMsg.NotUnfreeze') : this.$t('CargoMsg.Unfreeze')
          }
        },
        {
          headerName: this.$t('CargoMsg.SOCType'),
          field: 'socType',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-select',
            optionField: {
              label: 'chineseName',
              value: 'code'
            },
            attrs: {
              cellSelectAttrs: { fullOptionsCBFunc: () => [...SeaExportConstants.SOC_TYPE] }
            },
            valueChanged: p => {
              this.onCellChange(p)
            }
          }
        },
        {
          headerName: this.$t('queryJob.destinationAgent'),
          field: 'destinationAgent',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_2') : ''
          },
          width: 200,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_3') : ''
          },
          width: 200,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.UserDefinedField1'),
          field: 'userDefinedField1',
          width: 150,
          hide: true,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          onCellValueChanged: params => this.onCellChange(params)
        },
        {
          headerName: this.$t('SeaExport.UserDefinedField2'),
          field: 'userDefinedField2',
          width: 150,
          hide: true,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          onCellValueChanged: params => this.onCellChange(params)
        },
        {
          headerName: this.$t('SeaExport.UserDefinedField3'),
          field: 'userDefinedField3',
          width: 150,
          hide: true,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          onCellValueChanged: params => this.onCellChange(params)
        },
        {
          headerName: this.$t('SeaExport.UserDefinedField4'),
          field: 'userDefinedField4',
          width: 150,
          hide: true,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          onCellValueChanged: params => this.onCellChange(params)
        },
        {
          headerName: this.$t('queryJob.BusinessRemarks'),
          field: 'jobRemarks',
          width: 150,
          hide: true,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          onCellValueChanged: params => this.onCellChange(params)
        },
        {
          headerName: this.$t('queryJob.InternalEquipmentNote'),
          field: 'warehouseRemarks',
          width: 150,
          hide: true,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          onCellValueChanged: params => this.onCellChange(params)
        },
        {
          headerName: this.$t('queryJob.QuantityWeightCubageConfirmed'),
          field: 'quantityWeightCubageConfirmed',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.booleanColumnLabelFunc(params.value)
          },
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'el-checkbox',
            valueChanged: param => this.onCellChange(param)
          }
        },
        {
          headerName: this.$t('SeaExport.Package'),
          colId: 'packing',
          field: 'packing',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Packing,
              filterable: true,
              tagValue: 'code',
              customLabel: (item) => this.language === 'zh' ? `${item.chineseName}[${item.name}]` : `${item.name}[${item.chineseName}]`,
              showCustomLabelInOption: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p),
          valueFormatter: params => {
            return ColumnUtils.packingCodeLabelFun(params.value)
          }
        }
      ]
      if (this.enableUiCustom) {
        columnDefs.push({
          headerName: this.$t('SeaExport.NumberOfItemsReceived'),
          field: 'warehouseQuantity'
        })
        columnDefs.push({
          headerName: this.$t('SeaExport.GrossWeightUponEntry'),
          field: 'warehouseWeight',
          valueFormatter: (params) => {
            return NumberUtils.formatNumber(params.value, 3)
          }
        })
        columnDefs.push({
          headerName: this.$t('SeaExport.WarehouseVolume'),
          field: 'warehouseCubage',
          valueFormatter: (params) => {
            return NumberUtils.formatNumber(params.value, 3)
          }
        })
        return UICustomUtil.handleColumnLabelAndDisplay(columnDefs, this.containerElementDict)
      }
      return columnDefs
    },
    hqFlag() {
      if (this.job.containers.length > 0) {
        for (const data of this.job.containers) {
          // 记录HQ/HC箱型存在的标识
          if (data.eqType === 'HQ') {
            return true
          }
        }
        return false
      }
    },
    hcFlag() {
      if (this.job.containers.length > 0) {
        for (const data of this.job.containers) {
          // 记录HQ/HC箱型存在的标识
          if (data.eqType === 'HC') {
            return true
          }
        }
        return false
      }
    },
    HQHCFlag() {
      if (this.hqFlag && this.hcFlag) {
        return true
      }
      return false
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
  },
  methods: {
    loadPageConfig() {
      if (this.previewConfig) {
        this.warehouseElementDict = this.previewConfig.WarehouseInfo
        this.containerElementDict = this.previewConfig.ContainerInfo
        this.portElementDict = this.previewConfig.PortInfo
      } else {
        this.warehouseElementDict = UICustomUtil.getPageConfig(UICustomConstants.SEA_BOOKING_CONTAINER_INFO_MASTER, this.$store.getters.currentOfficeId, undefined, 'WarehouseInfo').elementDict
        this.containerElementDict = UICustomUtil.getPageConfig(UICustomConstants.SEA_BOOKING_CONTAINER_INFO_MASTER, this.$store.getters.currentOfficeId, undefined, 'ContainerInfo').elementDict
        this.portElementDict = UICustomUtil.getPageConfig(UICustomConstants.SEA_BOOKING_CONTAINER_INFO_MASTER, this.$store.getters.currentOfficeId, undefined, 'PortInfo').elementDict
      }
    },
    async onShow(row, isRefresh) {
      this.xinHaoQiApi = Number(this.context.config.get('xinHaoQiApi'))
      this.jingyuWarehouse = this.context.config.get('JingyuWarehouse') === '1'
      this.isUppercaseByConfig = Number(this.context.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
      this.toExoSystemJYD = this.context.config.get('ToExoSystem') === 'JYD'
      this.portareaDialogVisible = false
      if (!isRefresh) {
        return
      }
      // this.operationTipsArray = []

      const job = new SeaExportJob(row)
      // 复制，拆分 动作 无uuid
      if (row.uuid) {
        await Promise.all([
          job.getSeaEQ(),
          job.getLclSlaves(),
          job.getContainers(),
          job.getPoItems()
        ])
        this.job = job
        if (!job.containers) {
          job.containers = []
        }
        const jydEnable = LocalStorageUtils.getConfiguration(this.job.jobNo + '-msdSendApi')
        if (jydEnable) {
          this.jydEnable = jydEnable
        }
        if (job.containers.length > 0) {
          job.containers.forEach((item) => {
            item.newContainerNo = item.containerNo
          })
        }
        this.containers = job.containers
        this.lclSlaves = this.job.lclSlaves
        this.loadWarehouseIn(this.lclSlaves)
        if (this.lclSlaves) {
          for (const j of this.lclSlaves) {
            j.quantityStr = this.slaveQuantityLabelFunc(j)
            j.weightStr = this.slaveWeightLabelFunc(j)
            j.cubageStr = this.slaveCubageLabelFunc(j)
            j.quantityContractStr = this.slaveQuantityContractLabelFunc(j)
            j.weightContractStr = this.slaveWeightContractLabelFunc(j)
            j.cubageContractStr = this.slaveCubageContractLabelFunc(j)
          }
          this.refreshSlaveWarehouseQWC(this.lclSlaves)
        }
        this.poItems = this.job.poItems && this.job.poItems.length > 0 ? this.job.poItems.sort((a, b) => {
          return a.sequenceNo - b.sequenceNo
        }) : []
        await this.toXhqGetCustomsUnFrozenState()
      } else {
        row.seaEQ = []
        row.lclSlaves = []
        row.containers = []
        this.warehouseQWCMap = new Map()
      }

      this.mergeHarbourList = []

      if (job.uuid) {
        await this.initHarbour()
        if (!row.lclMasterUuid) {
          await this.portContainerInfoFunc(row)
        }
        this.initCompare()
      }
      this.pm.commitProperties()
      if (this.enableUiCustom) {
        UICustomUtil.handleViewAndWrite(UICustomConstants.SEA_BOOKING_CONTAINER_INFO_MASTER, this.warehouseElementDict, row)
        UICustomUtil.handleViewAndWrite(UICustomConstants.SEA_BOOKING_CONTAINER_INFO_MASTER, this.containerElementDict, row)
        UICustomUtil.handleViewAndWrite(UICustomConstants.SEA_BOOKING_CONTAINER_INFO_MASTER, this.portElementDict, row)
      }
    },
    async loadWarehouseIn(slaveJobs) {
      this.warehouseQWCMap = new Map()
      if (slaveJobs && slaveJobs.length > 0) {
        const ajaxList = []
        for (const slaveJob of slaveJobs) {
          ajaxList.push(warehouseInList(slaveJob.uuid).then(res => {
            for (const obj of res.data) {
              if (obj.parent) {
                let quantity = 0
                let weight = 0
                let cubage = 0
                const detailList = res.data.filter(val => {
                  return val.warehouseInUuid === obj.uuid
                })
                for (const item of detailList) {
                  quantity = quantity + item.quantity
                  weight = weight + item.weight
                  cubage = cubage + item.cubage
                }
                let qwc = this.warehouseQWCMap.get(slaveJob.uuid + '-' + obj.warehouseNo)
                if (!qwc) {
                  qwc = { quantity: 0, weight: 0, cubage: 0 }
                  this.warehouseQWCMap.set(slaveJob.uuid + '-' + obj.warehouseNo, qwc)
                }
                qwc.quantity += quantity
                qwc.weight += weight
                qwc.cubage += cubage
              }
            }
          }))
        }
        await Promise.all(ajaxList)
      }
    },
    // 计算重复箱子数量
    counterArray(arr) {
      var obj = {}
      arr.forEach(function(v, k) {
        if (obj[v]) {
          obj[v]++
        } else {
          obj[v] = 1
        }
      })
      return obj
    },
    // 获取港区箱子
    async portContainerInfoFunc(row) {
      const params = {
        jobUuid: row.uuid,
        userId: this.$store.getters.userId,
        discriminate: 2,
        tenantId: row.tenantId
      }
      try {
        const res = await portContainerInfo(params)
        if (res.ok && res.data.length > 0) {
          this.container.harbourDistrict = []
          this.container.basicTab = []
          this.contentShow = true
          // 箱量不一致弹出
          const containerArr = []
          // 计算有多少个箱号
          for (const data of res.data) {
            if (!containerArr.includes(data.containerNo)) {
              containerArr.push(data.containerNo)
            }
          }
          // 记录箱号有几个，用于判断箱量是否相等
          const containersNum = containerArr.length
          for (const data of res.data) {
            // 标记无容器高度
            this.containerHeightFlag = !!data.containerHeightCn
            // 转换箱型箱种的映射
            data.eqtype = PortDataCompareUtils.transformEqType(data.eqtype, data.containerHeightCn, this.HQHCFlag)
            containerArr.forEach((item, index) => {
              // 港区数据与所有不重复的箱号进行对比，记录箱型箱种
              if (item === data.containerNo) {
                // 转换后的eqtype为数组 如数组长度大于1代表映射关系有两种，取HC作为弹窗内的默认显示值
                if (data.eqtype.length > 1) {
                  if (data.containerHeightCn) {
                    // this.container.harbourDistrict.push(`${data.eqsize}'HC`)
                    if (!this.hqFlag || !this.hcFlag) {
                      if (this.hqFlag) {
                        this.container.harbourDistrict.push(`${data.eqsize}'HQ`)
                      } else {
                        this.container.harbourDistrict.push(`${data.eqsize}'HC`)
                      }
                    }
                  } else {
                    if (!this.hqFlag || !this.hcFlag) {
                      if (this.hqFlag) {
                        this.container.harbourDistrict.push(`${data.eqsize}'HQ`)
                      } else {
                        this.container.harbourDistrict.push(`${data.eqsize}'HC`)
                      }
                    }
                  }
                } else {
                  this.container.harbourDistrict.push(`${data.eqsize}'${data.eqtype}`)
                }
                containerArr.splice(index, 1)
              }
            })
          }
          // 统计重复的箱子，避免提示的箱型箱种有多个重复的
          const totalize = this.counterArray(this.container.harbourDistrict)
          const temporaryArr = []
          Object.keys(totalize).forEach((item) => {
            temporaryArr.push(`${item}*${totalize[item]}`)
          })
          this.container.harbourDistrict = temporaryArr

          if (row.containers.length > 0) {
            for (const data of row.containers) {
              this.container.basicTab.push(`${data.eqSize}'${data.eqType}`)
            }
            const containers = this.counterArray(this.container.basicTab)
            const newContainers = []
            Object.keys(containers).forEach((item) => {
              newContainers.push(`${item}*${containers[item]}`)
            })
            this.container.basicTab = newContainers
          }
          if (row.containers.length !== containersNum) {
            this.contentShow = false
          } else {
            if (!this.container.basicTab.every(el => this.container.harbourDistrict.indexOf(el) !== -1)) {
              this.contentShow = false
            }
          }
          if (!(this.hasCompareYet && this.contentShow)) {
            this.portareaDialogVisible = true
          }
        }
      } catch (e) {

      }
    },
    // 保存数据提交
    getSubmitData() {
      if (this.enableUiCustom) {
        UICustomUtil.checkRowDataRequire(this.job.containers, this.portElementDict, 'tabLclContainer')
        for (const container of this.job.containers) {
          UICustomUtil.checkRowDataRequire(container.containerUsage, this.containerElementDict, 'tabLclContainer', (row, element) => {
            if (row.jobNo) {
              return ` 【${this.$t('SeaExport.BusinessNo')}：${row.jobNo}】${element.label} `
            }
            return element.label
          })
        }
      }
      this.pm.validateForm()
      const cargoDocKeySet = new Set()
      if (this.job.seaCargoDoc) {
        for (const cargoDoc of this.job.seaCargoDoc) {
          cargoDocKeySet.add(cargoDoc.uuid)
        }
      }
      const lclSlaves = []
      // operationTips 数据处理(设置更新标识)
      for (const container of this.job.containers) {
        if (container.newContainerNo && !container.containerNo) {
          container.wharfReleaseDate = ''
          container.wharfReleaseState = ''
          container.wharfStowage = ''
          container.wharfStowageState = ''
          container.customReleaseDate = ''
          container.customReleaseState = ''
          container.approachDate = ''
          container.playDate = ''
        }
        for (const usage of container.containerUsage) {
          // const index = this.operationTipsArray.findIndex(p => p.jobUuid === usage.jobUuid)
          // if (index > -1) {
          //   usage.operationTipsDirty = true
          // }
          if (usage.poItems === '') {
            usage.poItems = []
          }
          let updateEdiContainer = false
          if (this.job.uuid && usage.ediContainers && usage.ediContainers.length > 0) {
            for (const ediContainer of usage.ediContainers) {
              if (!cargoDocKeySet.has(ediContainer.cargoDocUuid) && (ediContainer.containerNo !== container.containerNo || ediContainer.sealNo !== container.sealNo)) {
                ediContainer.containerNo = container.containerNo
                ediContainer.sealNo = container.sealNo
                updateEdiContainer = true
              }
            }
          }
          if (!updateEdiContainer) {
            delete usage.ediContainers
          }
          if (usage.ediContainer) {
            if (usage.ediContainer.containerNo !== container.containerNo || usage.ediContainer.sealNo !== container.sealNo) {
              usage.ediContainer.containerNo = container.containerNo
              usage.ediContainer.sealNo = container.sealNo
            } else {
              delete usage.ediContainer
            }
          }
          if (usage.jobDirty || usage.lobSubTableDirty || usage.warehouseDirty) {
            const lclSlave = this.job.lclSlaves.find(p => p.uuid === usage.jobUuid)
            if (lclSlave && !lclSlaves.includes(lclSlave)) {
              if (usage.jobDirty) {
                lclSlave.userDefinedField1 = usage.userDefinedField1
                lclSlave.userDefinedField2 = usage.userDefinedField2
                lclSlave.userDefinedField3 = usage.userDefinedField3
                lclSlave.userDefinedField4 = usage.userDefinedField4
                lclSlave.remarks = usage.jobRemarks
              }
              if (usage.lobSubTableDirty) {
                lclSlave.soNo = usage.soNo
                lclSlave.operationTips = usage.operationTips
                lclSlave.lobSubTableDirty = true
              }
              if (usage.warehouseDirty) {
                lclSlave.warehouseRemarks = usage.warehouseRemarks
                lclSlave.warehouseDirty = true
              }
              lclSlaves.push(lclSlave)
            }
          }
        }
      }
      const result = {
        lclSlaves,
        poItems: this.poItems,
        containers: this.job.containers, // .filter(p => p.isDirty === true),
        delContainerUuids: this.job.delContainerUuids, // 删除的箱子uuid
        delContainerUsageUuids: this.job.delContainerUsageUuids // 删除的装箱uuid
      }
      if (this.selection && this.selection.length > 0) {
        result['confirmedVOS'] = this.selection
      }
      if (this.job.seaEQ && this.job.seaEQ.length > 0) {
        result['seaEQ'] = this.job.seaEQ.filter(p => p.isDirty === true)
      }
      // todo 重新组装数据 过滤 container.containerUsages isDirty=true 至后端保存
      return result
    },

    // 箱子列编辑
    containerItemEditEndHandler(params) {
      params.data.isDirty = true // 用于校验数据是否修改标识
      if (params.field === 'sealNo') {
        params.data.isReSealed = true // 此属性赋值未用上
      }
      if (params.field === 'containerWeight') {
        // 箱重处理四舍五入 入库（控件只做了前端显示处理）
        if (params.data.containerWeight) {
          params.data.containerWeight = roundHalfUp(params.data.containerWeight, 3)
        } else {
          params.data.containerWeight = 0
        }
      }
      if (params.field === 'containerNo' || params.field === 'sealNo') {
        const container = params.data
        if (this.job.uuid && container.containerUsage) {
          let updateEdiContainer = false
          for (const usage of container.containerUsage) {
            if (usage.ediContainers && usage.ediContainers.length > 0) {
              for (const ediContainer of usage.ediContainers) {
                if ((ediContainer.containerNo !== container.containerNo || ediContainer.sealNo !== container.sealNo)) {
                  updateEdiContainer = true
                  this.$message.success(this.$t('Message.SyncContainerSealNoToBillOfLading'))
                  break
                }
              }
            }
            if (updateEdiContainer) {
              break
            }
          }
        }
      }
    },
    // 列编辑修改事件 (usageItemEditEndHandler)
    onCellChange(params) {
      const usage = params.data
      const field = params.colDef ? params.colDef.field : params.field
      if (!usage) {
        return
      }

      // 同步更新container的 usage
      for (const item of this.job.containers) {
        let bFlag = false
        for (const itemUsage of item.containerUsage) {
          if (itemUsage === usage) {
            item.isDirty = true
            bFlag = true
            break
          }
        }
        if (bFlag) {
          break
        }
      }
      usage.isDirty = true // 用于校验数据是否修改标识

      // 排序
      if (field === 'serialNo') {
        sortByMultiField(this.selectedContainer.containerUsage, ['serialNo'], false)
      }

      // // operationTips 是 job 上的信息
      // if (field === 'operationTips') {
      //   const slave = this.job.lclSlaves.find(p => p.uuid === usage.jobUuid)
      //   if (slave) {
      //     slave.operationTips = params.data.operationTips
      //   }
      //   for (const container of this.job.containers) {
      //     for (const item of container.containerUsage) {
      //       if (item.jobUuid === usage.jobUuid) {
      //         item.operationTips = slave.operationTips
      //       }
      //     }
      //   }

      //   // 记录 需要修改的operationTips
      //   const operationTipsObj = this.operationTipsArray.find(p => p.jobUuid === usage.jobUuid)
      //   if (!operationTipsObj) {
      //     const obj = { jobUuid: usage.jobUuid, operationTips: usage.operationTips }
      //     this.operationTipsArray.push(obj)
      //   } else {
      //     operationTipsObj.operationTips = usage.operationTips
      //   }
      // }

      // 装箱件毛体刷新至箱子上 件毛体合计 刷新至箱子上  h5 新增需求，cargo 中无此功能
      if (field === 'quantity' || field === 'weight' || field === 'cubage') {
        this.pm.refreshContainerQwc()
      }

      switch (field) {
        case 'userDefinedField1':
        case 'userDefinedField2':
        case 'userDefinedField3':
        case 'userDefinedField4':
        case 'jobRemarks':
          usage.jobDirty = true
          break
        case 'soNo':
        case 'operationTips':
          usage.lobSubTableDirty = true
          break
        case 'warehouseRemarks':
          usage.warehouseDirty = true
          break
      }

      this.pm.refreshSalves()
      for (const j of this.lclSlaves) {
        j.quantityStr = this.slaveQuantityLabelFunc(j)
        j.weightStr = this.slaveWeightLabelFunc(j)
        j.cubageStr = this.slaveCubageLabelFunc(j)
        j.quantityContractStr = this.slaveQuantityContractLabelFunc(j)
        j.weightContractStr = this.slaveWeightContractLabelFunc(j)
        j.cubageContractStr = this.slaveCubageContractLabelFunc(j)
      }
      this.refreshSlaveWarehouseQWC(this.lclSlaves)
    },
    // 验更改封号
    changeSealHandler() {
      if (!this.selectedContainer) { return }
      this.boxNoDialog.visible = true
    },
    // 查验更改封号 回调事件
    sealCloseHandler(data) {
      const container = this.selectedContainer
      if (container.sealNo !== data.sealNo) {
        container.isReSealed = true
        container.inSpected = true
      }
      container.sealNo = data.sealNo
      container.containerNo = data.containerNo
      container.remark = data.remark
      container.isDirty = true
      if (this.job.uuid && container.containerUsage) {
        let updateEdiContainer = false
        for (const usage of container.containerUsage) {
          if (usage.ediContainers && usage.ediContainers.length > 0) {
            for (const ediContainer of usage.ediContainers) {
              if ((ediContainer.containerNo !== container.containerNo || ediContainer.sealNo !== container.sealNo)) {
                updateEdiContainer = true
                this.$message.success(this.$t('Message.SyncContainerSealNoToBillOfLading'))
                break
              }
            }
          }
          if (updateEdiContainer) {
            break
          }
        }
      }
      this.left.gridApi.refreshCells({ force: true })
    },
    containerNbrStyleFunction(container) {
      if (container) {
        if (!ContainerNoHelper.checkContainerNo(container.containerNo)) {
          return 'data-red'
        }
        if (DataPushCompareUtils.comparePushData(this.$t('SeaExport.ContainerNo'), container.containerNo, container.uuid)) {
          return 'data-blue'
        }
      }
      return ''
    },
    getSlaveContainerUsages(slaveUuid) {
      const result = []
      for (const container of this.containers) {
        if (container.containerUsage) {
          for (const containerUsageItem of container.containerUsage) {
            if (containerUsageItem.jobUuid === slaveUuid) {
              result.push(containerUsageItem)
            }
          }
        }
      }
      return result
    },
    slaveQuantityLabelFunc(data) {
      return Job.getUnboxedQuantityActual(data.quantityActual, this.getSlaveContainerUsages(data.uuid))
    },
    slaveWeightLabelFunc(data) {
      return NumberUtils.formatNumber(Job.getUnboxedWeightActual(data.weightActual, this.getSlaveContainerUsages(data.uuid)), 3)
    },
    slaveCubageLabelFunc(data) {
      return NumberUtils.formatNumber(Job.getUnboxedCubageActual(data.cubageActual, this.getSlaveContainerUsages(data.uuid)), 3)
    },
    slaveQuantityContractLabelFunc(data) {
      return Job.getUnboxedQuantityContract(data.quantityContract, this.getSlaveContainerUsages(data.uuid))
    },
    slaveWeightContractLabelFunc(data) {
      return NumberUtils.formatNumber(Job.getUnboxedWeightContract(data.weightContract, this.getSlaveContainerUsages(data.uuid)), 3)
    },
    slaveCubageContractLabelFunc(data) {
      return NumberUtils.formatNumber(Job.getUnboxedCubageContract(data.cubageContract, this.getSlaveContainerUsages(data.uuid)), 3)
    },
    refreshSlaveWarehouseQWC(rows) {
      for (const row of rows) {
        const qwc = this.warehouseQWCMap.get(row.uuid + '-' + row.warehouseNo)
        row.warehouseQuantity = qwc?.quantity || 0
        row.warehouseWeight = qwc?.weight || 0
        row.warehouseCubage = qwc?.cubage || 0
      }
    },
    containerAscriptionFunc(val) {
      for (const item of SeaExportConstants.CONTAINER_ASCRIPTION_TYPE) {
        if (item.code === val) {
          return item.chineseName
        }
      }
    },
    /**
     * 放行信息转换
     */
    releaseDateLabelFunc(data, fieldName) {
      if (data != null) {
        const value = data[fieldName]
        if (value) {
          return 'Y(' + ColumnUtils.dateLabelFunc(value) + ')'
        }
      }
      return 'N'
    },
    subInSpectedLabelFunc(data) {
      if (data) {
        const isInSpected = data.inSpected
        return isInSpected ? this.$t('Message.Yes') : this.$t('Message.No')
      }
      return ''
    },
    containerChangeHandler(event) {
      this.pm.containerChangeHandler(event)
    },
    // 小票行选中
    onRowClicked(event) {
      this.selectedSlave = event.data
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedSlave = node.data
          }
        })
      }
    },
    onCellFocusedContainer(event) {
      if (this.left.gridOptions.api && event.column) {
        this.left.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedContainer = node.data
          }
          this.pm.refreshUsages()
        })
      }
    },
    // 组装打印参数
    getPrintData() {
      if (this.job && this.job.masterFlag) {
        const containers = this.left.gridApi.getSelectedRows()
        const params = {}
        if (containers.length === 0) {
          this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
          return
        }
        if (containers.length === 1) {
          const container = new Container(containers[0])
          params.CONTAINER_UUID = container.uuid
          params.jobuuid = this.job ? this.job.uuid : ''
          params.category = 'LCL'
          params.ctx = new SeaExportJob(this.job)
          // TemplateSelectorWin.getInstance().showThisWin(job, "LCL", params, this);
        } else {
          params.CONTAINER_UUID = Array.from(containers, p => p.uuid)
          params.jobuuid = this.job ? this.job.uuid : ''
          params.category = 'CONTAINER_LIST'
          params.ctx = new SeaExportJob(this.job)
          // TemplateSelectorWin.getInstance().showThisWin(job, "CONTAINER_LIST", params, this);
        }
        return params
      }
    },
    // 初始处理港区数据
    initGoodsTmpInfo() {
      this.mergeHarbourList = []
      if (this.harbourList.length > 0) {
        this.harbourList.forEach(elements => {
          // 关单号转大写
          elements.soNo = elements.soNo ? elements.soNo.toUpperCase() : ''
          if (this.mergeHarbourList.length === 0) {
            this.mergeHarbourList.push(deepClone(elements))
          } else {
            let isIn = false
            this.mergeHarbourList.forEach(element => {
              element.eqTypeArr = CommonUtil.transformationEqType(element.eqType, element.containerHeightCn, this.HQHCFlag)
              if (element.containerNo === elements.containerNo && elements.containerNo && element.containerNo) {
                isIn = true
                if (!element.eqSize && elements.eqSize) {
                  element.eqSize = elements.eqSize
                }
                if (!element.eqType && elements.eqType) {
                  element.eqType = elements.eqType
                }
                if (!element.cargoEnglishName && elements.cargoEnglishName) {
                  element.cargoEnglishName = elements.cargoEnglishName
                }
                if (!element.hsCode && elements.hsCode) {
                  element.hsCode = elements.hsCode
                }
                if (!element.packing && elements.packing) {
                  element.packing = elements.packing
                }
                element.quantity = PortDataCompareUtils.adding(element.quantity, elements.quantity, true)
                element.weight = PortDataCompareUtils.adding(element.weight, elements.weight, false)
                element.cubage = PortDataCompareUtils.adding(element.cubage, elements.cubage, false)
                if (!element.soNo && elements.soNo) {
                  element.soNo = elements.soNo
                }
              }
            })
            if (!isIn) {
              this.mergeHarbourList.push(deepClone(elements))
            }
          }
        })
      }
    },
    // 数据对比弹框
    harbourCompare() {
      if (this.openPortDataService !== 4) {
        this.harbourWarnMessage()
        return
      }
      this.sourceList = [...this.harbourList]
      this.sourceList.forEach((item) => {
        this.selection.map((uasge) => {
          if (item.uuid === uasge.uuid) {
            if (!uasge.hasOwnProperty('sameWithHarborDistrict') || !uasge.sameWithHarborDistrict) {
              item.confirmed = uasge.confirmed
            }
          }
        })
      })
      this.harbourDialog = true
      this.checkHarbour()
      if (this.harbourCheckRead) {
        updateRead({ jobUuid: this.job.uuid }).then(() => {
          this.harbourCheckRead = false
        })
      }
    },
    checkHarbour() {
      const lclSlaveSoNo = {}
      const lclSlavesList = [...this.job.lclSlaves]
      const soNoList = []
      if (lclSlavesList.length > 0) {
        // 多个so时，拆开为单个so
        lclSlavesList.forEach(element => {
          const soNo = element.soNo
          if (!soNo) {
            this.hasSoNo = false
          } else {
            if (element.soNo.includes('\n')) {
              element.soNo = element.soNo.replace(/\n/g, ',')
            }
            if (element.soNo.includes(',')) {
              const soNoArr = element.soNo.split(',')
              soNoArr.map((v, i) => {
                const newItem = JSON.parse(JSON.stringify(element))
                newItem.soNo = v
                soNoList.push(newItem)
                lclSlaveSoNo[soNo.toUpperCase()] = newItem
              })
            } else {
              soNoList.push(element)
              lclSlaveSoNo[soNo.toUpperCase()] = element
            }
          }
        })
      }
      this.lclSlaveSoNo = lclSlaveSoNo
      const h = this.$createElement
      if (!this.hasSoNo) {
        this.$msgbox({
          message: h('div', { class: 'portData-check' }, [
            h('i', { class: 'el-icon-error' }, ''),
            h('strong', null, this.$t('SeaExport.SIsMissingAndVerified')),
            h('p', null, this.$t('SeaExport.PleaseNoForTheFirst'))
          ]),
          showCancelButton: false,
          confirmButtonText: this.$t('Message.GotIt')
        }).then(() => {
        })
        return true
      }
      this.checkSoNo = []
      this.harbourList.forEach(event => {
        let checkSoNo = false
        soNoList.forEach(events => {
          if (CommonUtil.stringEquals(event.soNo, events.soNo)) {
            checkSoNo = true
          }
        })
        if (!checkSoNo) {
          this.checkSoNo.push(event.soNo)
        }
      })
      if (this.checkSoNo.length > 0) {
        this.dialogVisible = true
        return true
      }
    },
    harbourWarnMessage() {
      let message = ''
      switch (this.openPortDataService) {
        case 1:
          message = this.$t('SeaExport.HarbourNotInServiceNoOpen') + '021-65143931。'
          break
        case 2:
          message = this.$t('SeaExport.HarbourInServiceNoOpen') + '021-65143931。'
          break
        case 3:
          message = this.$t('SeaExport.HarbourNotInServiceOpen')
          break
      }
      const h = this.$createElement
      this.$msgbox({
        message: h('div', { class: 'portData-service' }, [
          h('i', { class: 'el-icon-warning' }, ''),
          h('span', null, this.$t('Message.Prompt')),
          h('p', null, message)
        ]),
        showCancelButton: false,
        confirmButtonText: this.$t('Message.GotIt')
      }).then(() => {
      })
    },
    // 同步港区数据
    harbourSync() {
      if (this.openPortDataService !== 4) {
        this.harbourWarnMessage()
        return
      }
      if (this.checkHarbour()) {
        return
      }
      this.$confirm(`<strong>【${this.$t('SeaExport.SynchronizePortData')}】${this.$t('SeaExport.TheOverwriteTheCurrentData')}</strong><br/><span style='color: red'>${this.$t('SeaExport.ThisActionCannotBeUndone')}</span>，${this.$t('SeaExport.DoYouWantToContinue')}`, this.$t('Message.Prompt'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('Invoice.invoice_confirm'),
        cancelButtonText: this.$t('Message.Cancel'),
        type: 'warning'
      }).then(() => {
        this.syncData()
      }).catch(() => {
      })
    },
    handleAddContainer(selection) {
      for (const slave of this.job.lclSlaves) {
        let sumQuantity = 0
        let sumWeight = 0
        let sumCubage = 0
        if (slave.containerUsages && slave.containerUsages.length > 0) {
          for (const usage of slave.containerUsages) {
            sumQuantity += Number(usage.quantity)
            sumWeight += Number(usage.weight)
            sumCubage += Number(usage.cubage)
          }
        }
        sumQuantity = Number(sumQuantity.toFixed())
        sumWeight = Number((Math.round(sumWeight * 100) / 100).toFixed(2))
        sumCubage = Number((Math.round(sumCubage * 1000) / 1000).toFixed(3))
        slave.weightActual = sumWeight
        slave.quantityActual = sumQuantity
        slave.cubageActual = sumCubage
      }
      // 装箱件毛体 可能是从基本页签同步而来 没有触发cellChange 方法，同步箱子上的件毛体
      for (const container of this.containers) {
        if (container.confirmed) {
          this.isAutoLoad = true
        }
        if (container.type === '新增') {
          // 处理从装箱信息数据对比新增的箱子
          if (StrUtils.isEmpty(container.uuid)) {
            const seaEQ = container.seaEQ
            PortDataCompareUtils.addSeaEQ(this.job.seaEQ, seaEQ.eqType, seaEQ.eqSize)
          }
        }
      }
      // 更新小票装箱信息
      this.refreshLclSlaves()
      this.selection = selection
    },
    // 初始化获取港区数据
    async initHarbour() {
      await getOpenPortDataService({ jobUuid: this.job.uuid }).then(async(res) => {
        this.openPortDataService = res.data
        if (this.openPortDataService === 4) {
          await checkRead({ jobUuid: this.job.uuid }).then(res => {
            this.harbourCheckRead = !res.data
          })
          await getGoodsTmpInfoByJobId({ jobUuid: this.job.uuid }).then(res => {
            this.harbourList = res.data
            let flag = false
            if (res.data && res.data.length > 0) {
              for (const data of res.data) {
                if (data.confirmed !== 0) {
                  flag = true
                }
              }
            }
            this.hasCompareYet = flag
            this.initGoodsTmpInfo()
          })
        }
      })
    },
    syncData() {
      this.isAutoLoad = false
      const harbourList = []
      this.harbourList.forEach(item => {
        item.confirmed = 10
      })
      const tempHarbour = deepClone(this.harbourList)
      this.selection = []
      this.containers.forEach((element, keys) => {
        delete element.type
        tempHarbour.forEach((eve, index) => {
          eve.eqTypeArr = CommonUtil.transformationEqType(eve.eqType, eve.containerHeightCn, this.HQHCFlag)
          // 箱号不为空，且箱号相同的数据，或当前业务的箱号为空，港区的箱号不为空且箱型箱量相同的
          if ((!StrUtils.isEmpty(eve.containerNo) && (eve.containerNo === element.containerNo)) ||
            (StrUtils.isEmpty(element.containerNo) && eve.containerNo && PortDataCompareUtils.checkEqSize(eve.eqSize, element.eqSize) && eve.eqTypeArr.includes(element.eqType))) {
            element.confirmed = 10
            // 通过soNo找到小票UUID
            element.containerNo = eve.containerNo
            PortDataCompareUtils.syncPortDate(eve, element)
            element.sealNo = eve.sealno
            if (this.lclSlaveSoNo.hasOwnProperty(eve.soNo)) {
              const slaveKey = this.lclSlaveSoNo[eve.soNo].uuid
              let flag = false
              for (const tempUsage of element.containerUsage) {
                if (tempUsage.jobUuid === slaveKey) {
                  PortDataCompareUtils.syncPortDate(eve, tempUsage)
                  tempUsage.quantity = eve.quantity
                  tempUsage.cubage = eve.cubage
                  tempUsage.weight = eve.weight
                  eve.type = '修改'
                  flag = true
                }
              }
              if (!flag) {
                const usage = PortDataCompareUtils.addLclContainerUsage('修改', eve, this.lclSlaveSoNo)
                usage.containerUuid = element.uuid
                usage.uuid = ''
                element.containerUsage.push(usage)
              }
              eve.type = '修改'
              this.isAutoLoad = true
              this.selection.push({
                uuid: eve.uuid,
                confirmed: 10,
                jobUuid: slaveKey
              })
              harbourList.push(eve.uuid)
            }
          }
        })
        PortDataCompareUtils.removeHarbourData(harbourList, tempHarbour)
      })
      // 箱号不一致 && 没有匹配的箱型箱种 && 港区数据 >= 当前数据
      const newContainer = {}
      tempHarbour.forEach((eve, index) => {
        PortDataCompareUtils.addLclContainer(eve, newContainer, this.job.uuid, this.lclSlaveSoNo)
        this.isAutoLoad = true
        const slaveKey = this.lclSlaveSoNo[eve.soNo].uuid
        this.selection.push({
          uuid: eve.uuid,
          confirmed: 10,
          jobUuid: slaveKey
        })
      })
      for (const key in newContainer) {
        const item = newContainer[key]
        item.confirmed = 10
        const seaEQ = item.seaEQ
        this.job.containers.push(item)
        PortDataCompareUtils.addSeaEQ(this.job.seaEQ, seaEQ.eqType, seaEQ.eqSize)
      }
      this.refreshLclSlaves()
    },
    refreshLclSlaves() {
      const lclSlaveUsageMap = {}
      for (const container of this.containers) {
        // 处理小票装箱数据
        for (const containerUsage of container.containerUsage) {
          if (!lclSlaveUsageMap.hasOwnProperty(containerUsage.jobUuid)) {
            lclSlaveUsageMap[containerUsage.jobUuid] = []
          }
          const lclSlaveUsages = lclSlaveUsageMap[containerUsage.jobUuid]
          lclSlaveUsages.push(containerUsage)
        }
      }
      // 更新小票装箱信息
      for (const slaves of this.lclSlaves) {
        slaves.containerUsages = lclSlaveUsageMap[slaves.uuid]
      }
      this.changeLclSlaves()
      this.pm.refreshContainerQwc()
      this.pm.refreshSalves()
      this.left.gridApi.clearFocusedCell()
      this.left.gridApi.refreshCells({ force: true })
      this.right.gridApi.clearFocusedCell()
      this.right.gridApi.refreshCells({ force: true })
      this.gridApi.clearFocusedCell()
      this.gridApi.refreshCells({ force: true })
    },
    // 初始化港区数据与当前装箱信息对比校验
    initCompare() {
      this.containers.forEach(containerUsage => {
        if (containerUsage.confirmed === 0 || containerUsage.confirmed === -1) {
          this.mergeHarbourList.forEach(harborDistrictData => {
            harborDistrictData.eqTypeArr = CommonUtil.transformationEqType(harborDistrictData.eqType, harborDistrictData.containerHeightCn, this.HQHCFlag)
            this.containerHeightFlag = !!harborDistrictData.containerHeightCn
            if (containerUsage.containerNo === harborDistrictData.containerNo) { // 找到containerNo相同的数据
              if (harborDistrictData.confirmed === 0) {
                if (containerUsage.sealNo !== harborDistrictData.sealno ||
                  !PortDataCompareUtils.checkEqSize(harborDistrictData.eqSize, containerUsage.eqSize) ||
                  !harborDistrictData.eqTypeArr.includes(containerUsage.eqType) ||
                  containerUsage.quantity !== harborDistrictData.quantity ||
                  containerUsage.weight !== harborDistrictData.weight ||
                  containerUsage.cubage !== harborDistrictData.cubage) {
                  containerUsage.confirmed = -1
                  // 是否与港区数据一致
                  containerUsage.sameWithHarborDistrict = false
                } else {
                  containerUsage.confirmed = 10
                  // 是否与港区数据一致
                  containerUsage.sameWithHarborDistrict = true
                  this.isAutoLoad = true
                }
              }
            }
          })
        }
        if (containerUsage.confirmed === 10 || containerUsage.confirmed === 11 || containerUsage.confirmed === 12 || containerUsage.confirmed === 13) {
          this.isAutoLoad = true
        }
      })
      this.$nextTick(() => {
        this.left.gridApi.clearFocusedCell()
        this.left.gridApi.refreshCells({ force: true })
        this.right.gridApi.clearFocusedCell()
        this.right.gridApi.refreshCells({ force: true })
        this.gridApi.clearFocusedCell()
        this.gridApi.refreshCells({ force: true })
      })
    },
    changeLclSlaves() {
      if (this.lclSlaves) {
        for (const j of this.lclSlaves) {
          j.quantityStr = this.slaveQuantityLabelFunc(j)
          j.weightStr = this.slaveWeightLabelFunc(j)
          j.cubageStr = this.slaveCubageLabelFunc(j)
          j.quantityContractStr = this.slaveQuantityContractLabelFunc(j)
          j.weightContractStr = this.slaveWeightContractLabelFunc(j)
          j.cubageContractStr = this.slaveCubageContractLabelFunc(j)
        }
        this.refreshSlaveWarehouseQWC(this.lclSlaves)
      }
    },
    async xhqShowSendContainerHandler() {
      this.xhqSendContainerDialog.containerUsage = [...this.selectedContainer.containerUsage]
      const containerUsage = this.xhqSendContainerDialog.containerUsage
      if (!containerUsage || !(containerUsage.length > 0)) {
        this.$message.warning(this.$t('CargoMsg.NoContainerInfo'))
        return
      }
      const jobUuidList = Array.from(containerUsage, p => p.jobUuid)
      const dataList = await xhqGetContainerLclList(jobUuidList).then(res => {
        return res.data
      })
      if (dataList && dataList.length > 0) {
        for (const item of containerUsage) {
          const dataMap = dataList.find(p => p.jobUuid === item.jobUuid)
          if (dataMap.xhqCustomState === XhqCustomState.NOT_SENT.code) {
            item.tips = this.$t('CargoMsg.NotSentCustomsFile')
          }
          if (!dataMap.customs) {
            item.remarks = this.$t('CargoMsg.SelfDeclaration')
          }
        }
      }
      this.xhqSendContainerDialog.visible = true
    },
    toXhqCustomsUnFrozenHandler() {
      this.$confirm(this.$t('CargoMsg.NotifyCustomsUnfreeze'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        this.xhqCustomsUnFrozenHandler()
      }).catch(() => {
      })
    },
    async xhqCustomsUnFrozenHandler() {
      const containers = this.left.gridApi.getSelectedRows()
      if (!containers || !(containers.length > 0)) return
      const operator = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', this.$store.getters.userId)
      const data = {
        jobNos: [],
        phone: operator ? operator.cell : '',
        hdUserName: operator ? operator.chineseName : '',
        opOffice: this.job.opOffice,
        jobUuid: this.job.uuid
      }
      for (const container of containers) {
        for (const containerUsage of container.containerUsage) {
          data.jobNos.push(containerUsage.jobNo)
        }
      }
      await xhqCustomsUnFrozen(data).then(res => {
        if (res.data) {
          this.$message.warning(res.data)
        } else {
          this.$message.success(this.$t('SeaExport.SendSucceeded'))
        }
      })
      await this.toXhqGetCustomsUnFrozenState()
      this.right.gridApi.refreshCells({ force: true })
    },
    // CARGO-37555 当开启信号旗报关参数时，需要关联箱子信息和报关信息，新增显示列报关状态，在这里查询出报关解冻状态拼到行数据里面去
    async toXhqGetCustomsUnFrozenState() {
      if (this.openXhqCustomsAll && this.containers && this.containers.length > 0) {
        const jobUuids = []
        for (const container of this.containers) {
          for (const usage of container.containerUsage) {
            jobUuids.push(usage.jobUuid)
          }
        }
        if (!jobUuids || !(jobUuids.length > 0)) return
        // 根据业务uuid批量去查报关解冻状态
        const xhqCustomsStateMaps = await xhqGetCustomsUnFrozenState(jobUuids).then(res => {
          return res.data
        })
        if (!xhqCustomsStateMaps || !(xhqCustomsStateMaps.length > 0)) return
        for (const container of this.containers) {
          for (const usage of container.containerUsage) {
            const stateMap = xhqCustomsStateMaps.find(p => p.jobUuid === usage.jobUuid)
            if (stateMap) {
              if (stateMap.customsUnfrozenState) {
                usage.customsUnfrozenState = stateMap.customsUnfrozenState
              }
              if (stateMap.xhqCustomState) {
                usage.xhqCustomState = stateMap.xhqCustomState
              }
            }
          }
        }
      }
    },
    async toReleaseJY() {
      const flg = await checkIfReleased({ jobUuid: this.job.uuid }).then(res => {
        return res.data
      })
      if (flg) {
        this.$message.warning(this.$t('SeaExport.AlreadySentReleaseGoods'))
        return
      }
      this.jyReleaseDialog.visible = true
    },
    toTakeContainerJY() {
      this.jyTakeContainerDialog.containers = this.left.gridApi.getSelectedRows()
      if (this.jyTakeContainerDialog.containers.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
        return
      }
      this.jyTakeContainerDialog.visible = true
    },
    toContainerPreloadJY() {
      this.jyContainerPreloadDialog.containers = this.left.gridApi.getSelectedRows()
      if (this.jyContainerPreloadDialog.containers.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
        return
      }
      this.jyContainerPreloadDialog.visible = true
    },
    async toCanPushPreConfiguration() {
      this.$confirm(this.$t('SystemMaintenance.pushMasterData'), this.$t('SystemMaintenance.pushPreConfiguredInformation'), {
        confirmButtonText: this.$t('Invoice.invoice_confirm'),
        cancelButtonText: this.$t('Message.Cancel'),
        type: 'info',
        closeOnClickModal: false
      }).then(async() => {
        this.loading = getLoading()
        await jydSendJobInfo({ jobUuidList: [this.job.uuid], canSubmitManifest: 1 }).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_SendSuccess'))
          this.jydEnable = true
          LocalStorageUtils.setConfiguration(this.job.jobNo + '-msdSendApi', true)
        }).catch(error => this.$message.error(error)).finally(() => this.loading.close())
      })
    },
    toCancelContainerPreloadJY() {

    },
    showLclDynamicList() {
      this.jyLclDynamicDialog.visible = !this.jyLclDynamicDialog.visible
    },
    calculateQuantity() {
      if (this.lclSlaves) {
        for (const j of this.lclSlaves) {
          j.quantityStr = this.slaveQuantityLabelFunc(j)
          j.weightStr = this.slaveWeightLabelFunc(j)
          j.cubageStr = this.slaveCubageLabelFunc(j)
          j.quantityContractStr = this.slaveQuantityContractLabelFunc(j)
          j.weightContractStr = this.slaveWeightContractLabelFunc(j)
          j.cubageContractStr = this.slaveCubageContractLabelFunc(j)
        }
        this.refreshSlaveWarehouseQWC(this.lclSlaves)
      }
    }
  }
}
</script>

<style lang='scss'>
.data-red {
  color: #FF0000;
}

.data-blue {
  color: #0000ff;
}

#tabLclContainer {
  .data-red {
    input.el-input__inner {
      color: #FF0000;
    }
  }

  .data-blue {
    input.el-input__inner {
      color: #0000ff;
    }
  }

  .el-dialog__wrapper {
    pointer-events: none;
  }

  .el-dialog {
    pointer-events: auto;
  }
}
</style>
<style lang="scss" scoped>
.portData-service {
  padding-top: 10px;

  &>i {
    margin-right: 5px;
    color: #409EFF;
    font-size: 30px;
    vertical-align: middle;
  }

  &>span {
    line-height: 32px;
    vertical-align: middle;
    font-weight: bold;
    font-size: 16px;
    display: inline-block;
  }

  &>p {
    padding: 10px 0 10px 35px;
    line-height: 22px;
    font-size: 14px;
  }
}

.portData-check {
  padding-top: 10px;

  &>i {
    margin-right: 5px;
    color: red;
    font-size: 30px;
    vertical-align: middle;
  }

  strong {
    margin-left: 5px;
    font-size: 14px;
  }

  p {
    margin: 0 0 5px 0;
    padding-left: 40px;
  }
}
.lcl-dynamic-div {
  float:right;
}
.lcl-dynamic-span {
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  color:deepskyblue;
  cursor:pointer;
  padding-left: 5px;
}
</style>
